import { useQuery } from '@tanstack/react-query';
import { qetQueryManager, useWidgetQueryStatus } from '../state/queryManager';
import { useEffect, useMemo } from 'react';

function useWidgetQuery({ wid, queryKey, queryFn, options }) {
  const { queued } = useWidgetQueryStatus(wid);
  const queryManager = useMemo(() => qetQueryManager(wid), [wid]);

  const queryRes = useQuery(queryKey, () => queryManager.exec(queryFn), {
    ...options,
  });

  const res = useMemo(
    () => ({
      ...queryRes,
      queued,
    }),
    [queryRes, queued],
  );

  // cancel any queued query on unmount
  useEffect(() => {
    return () => {
      queryManager.abort();
    };
  }, []);

  return res;
}

export default useWidgetQuery;
